import React from "react";
import { createPortal } from "react-dom";

const ModalWrapper = ({ children }) =>
  createPortal(<>{children}</>, document.getElementById("portal"));

export default ModalWrapper;
